module.exports = __webpack_public_path__ + "img/labels-3-d-desktop.7608eecd.webp";